/**
 * featureDetection_Max_FieldLengths_Constants.ts
 *
 *    Keep in sync with Java class FieldLengthConstants
 */

export class FeatureDetection_Max_FieldLengths_Constants {

    static readonly FEATURE_DETECTION_MAX_LENGTH__DISPLAY_LABEL = 8; // DB: 300
    static readonly FEATURE_DETECTION_MAX_LENGTH__DESCRIPTION = 255; // DB: 5000
}